module.exports = __webpack_public_path__ + "static/img/money_num.ec9e597f.png";